export default {
	state: () => ({
		/**
		 * @type {import("shared/types/globalSettings").GlobalSettings}
		 */
		globalSettings: {
			NavigateToGatedSubSiteEnabled: false,
			DisableRedirectToProductPageForSamples: false,
			IsConsumerPrescriptionsEnabled: false,
			E1Tax: {
				IsE1TaxCalculationEnabled: false,
			},
			AutoLogoutWarningEnabled: true,
			AutoLogoutWarningDelay: 1,
		},
	}),
	getters: {
		getGlobalSettings: (state) => {
			return state.globalSettings;
		},
		getE1TaxSettings: (_, getters) => {
			return getters.getGlobalSettings.E1Tax;
		},
	},
	mutations: {
		setGlobalSettings: (state, globalSettings) => {
			state.globalSettings = { ...state.globalSettings , ...globalSettings };
		},
	},
}
